import React from "react";
import { ExclamationIcon, ExclamationCircleIcon, InformationCircleIcon, ShieldCheckIcon } from "@heroicons/react/solid";
import { riskLevel } from "../../utils/riskLevel";

const ICONS = {
    high: ExclamationIcon,
    medium: ExclamationCircleIcon,
    low: InformationCircleIcon,
    positive: ShieldCheckIcon,
};

/** Severity pill for a threat: icon + label, coloured by riskLevel(riskScore). */
export default function RiskBadge({ riskScore }) {
    const level = riskLevel(riskScore);
    const Icon = ICONS[level.key];
    return (
        <span
            className={`inline-flex items-center gap-1 whitespace-nowrap rounded-full px-2.5 py-1 text-xs font-semibold ring-1 ring-inset ${level.badge}`}
            title={`Risk score ${riskScore}`}
        >
            <Icon className="h-4 w-4 shrink-0" aria-hidden="true" />
            {level.label}
        </span>
    );
}
